import React from 'react'
import PropTypes from 'prop-types'
import LinkList from '../../components/LinkList'
import MenuContext from '../../util/MenuContext';
import { useTranslation } from 'react-i18next'

const Popular = ({ smallPadding, title }) => {
  const { t } = useTranslation()
  const { popular } = React.useContext(MenuContext)
  const items = popular.map(item => ({ name: item.label, url: item.url.path }))

  if (!title) {
    title = t("popular")
  }

  return <LinkList title={title} items={items} smallPadding={smallPadding} />
}

Popular.propTypes = {
  smallPadding: PropTypes.bool
}

Popular.defaultProps = {
  smallPadding: false
}

export default Popular
